// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCExNu0RbQx5JxbT6AT_PA6-y84idsbkQ4",
  authDomain: "homat-shmuel-hub.firebaseapp.com",
  databaseURL: "https://homat-shmuel-hub-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "homat-shmuel-hub",
  storageBucket: "homat-shmuel-hub.firebasestorage.app",
  messagingSenderId: "529666183679",
  appId: "1:529666183679:web:319b32a1096411e24417ca",
  measurementId: "G-027JSFKR7E"
};

// Check if we're running in local development
const isLocalhost = window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1' ||
                    window.location.hostname === '[::1]';

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
export const auth = getAuth(app);

// Connect to Auth emulator in local development
if (isLocalhost) {
  try {
    connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  } catch (error: any) {
    // Emulator already connected, ignore error
    if (error?.message?.includes('already been called') || error?.message?.includes('already connected')) {
      // Already connected, no action needed
    }
  }
}

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// Initialize database
const database = getDatabase(app);

// Connect to Database emulator in local development
if (isLocalhost) {
  try {
    connectDatabaseEmulator(database, 'localhost', 9000);
  } catch (error) {
    // Emulator already connected, ignore error
    console.log('Database emulator connection:', error);
  }
}

export { database };
export default app;
